<template lang="pug">
    div.slider(v-if="wines.length")
        div.slider-background
            div.slider-background-image
                div.container
                    img.is-block(src="../assets/images/slider/background.svg", v-if="brand")
                    img.is-block(:src="require('../assets/images/4_vinhos/backgrounds/' + brandid +  '.svg')", v-else)
            div.slider-background-color.has-background-white-ter
        div.slider-content
            div.container(v-show="!loading")
                div.columns.is-multiline(v-if="grid")
                    div.column.is-one-quarter(v-for="w in wines")
                        wine-thumbnail(:wine="w")
                div.columns.is-vcentered.is-centered.is-mobile(v-else)
                    div.column(v-if="showArrows")
                        img.slider-arrow.is-pointer(src="../assets/images/slider/left.svg", @mouseover="sliderPrev", @mouseleave="stopLoop")
                    div.column.is-10
                        div#wines-slider
                            wine-thumbnail(v-for="(w, idx) in wines", :key="'_' + idx", :wine="w", :brand="brand", @loaded="waitload")
                    div.column.has-text-right(v-if="showArrows")
                        img.slider-arrow.is-pointer(src="../assets/images/slider/right.svg" @mouseover="sliderNext", @mouseleave="stopLoop")
</template>

<script>

import Siema from 'siema'
import WineThumbnail from '@/components/wine-thumbnail'

export default {
    name: 'wine-list',
    components: {
        WineThumbnail
    },
    props: {
        wines: Array,
        brand: Boolean,
        grid: Boolean
    },
    data () {
        return {
            slider: null,
            interval: null,
            loading: true
        }
    },
    computed: {
        showArrows () {
            return this.wines.length > 4 || window.screen.width < 768
        },
        brandid () {
            return this.wines[0].id_categoria
        }
    },
    watch: {
        grid () {
            this.grid ? this.$nextTick(this.setHeight) : this.$nextTick(this.setSlider)
        },
        wines () {
            this.loading = true

            if (this.slider) {
                this.slider.destroy(true)
            }
        }
    },
    methods: {
        setSlider () {
            this.slider = new Siema({
                selector: '#wines-slider',
                duration: 500,
                easing: 'ease-out',
                perPage: window.screen.width > 1024 ? 4 : 1,
                startIndex: 0
            })
            this.setHeight()
        },

        setHeight () {
            const content = document.querySelector('.slider-content')
            const wrapper = document.querySelector('.slider')

            wrapper.style.height = content.offsetHeight + 'px'
        },

        sliderNext () {
            this.stopLoop()
            this.slider.next()
            this.interval = setInterval(() => this.slider.next(), 1000)
        },

        sliderPrev () {
            this.stopLoop()
            this.slider.prev()
            this.interval = setInterval(() => this.slider.prev(), 1000)
        },

        stopLoop () {
            clearInterval(this.interval)
        },

        waitload () {
            if (this.loading) {
                this.loading = false
                this.grid ? this.$nextTick(this.setHeight) : this.$nextTick(this.setSlider)
            }
        }
    }
}
</script>

<style lang="stylus" scoped>

.slider
    position relative
    margin-top 50px

    &-background
        height 100%
        display flex
        flex-direction column

        &-image img
            max-width 850px
            margin 0 auto

        &-color
            background-color red
            flex-grow 1

    &-content
        position absolute
        left 0
        right 0
        top 0

        @media screen and (max-width: 768px)
            padding 0px 10px

    &-arrow
        width 1rem
</style>
